import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h.01","key":"svg-0"}],["path",{"d":"M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5","key":"svg-1"}],["path",{"d":"M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3","key":"svg-2"}],["path",{"d":"M14 14l1 -1c.616 -.593 1.328 -.792 2.008 -.598","key":"svg-3"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-4"}],["path",{"d":"M17 21l4 -4","key":"svg-5"}]]

const IconPhotoCancel = createReactComponent('outline', 'photo-cancel', 'PhotoCancel', __iconNode);

export default IconPhotoCancel;